/**
 * @generated SignedSource<<ded5e8a546c314bdd357e2d65a44dc76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentConfigEditor_TreeNodeFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PassContentConfigEditor_TreeNodeFragment" | "RestartIfFailedContentConfigEditor_TreeNodeFragment" | "RestartIfPassedContentConfigEditor_TreeNodeFragment" | "RewardContentConfigEditor_TreeNodeFragment" | "StartContentConfigEditor_TreeNodeFragment">;
  readonly " $fragmentType": "ContentConfigEditor_TreeNodeFragment";
};
export type ContentConfigEditor_TreeNodeFragment$key = {
  readonly " $data"?: ContentConfigEditor_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentConfigEditor_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentConfigEditor_TreeNodeFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StartContentConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PassContentConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RestartIfFailedContentConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RestartIfPassedContentConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RewardContentConfigEditor_TreeNodeFragment"
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "ad64d04f08743aeee3c9bf54e2cc0b4e";

export default node;
